import type { Icon } from "@judo/model-api";
import InputAdornment from "@mui/material/InputAdornment";
import { IconRenderer } from "../renderers/IconRenderer";

/**
 * Build a MUI `startAdornment` for a TextField-based input if the model element
 * has an icon defined. Returns `undefined` when no icon is present so that callers
 * can spread the result into slotProps without conditional logic.
 *
 * @example
 * ```tsx
 * <TextField slotProps={{ input: { startAdornment: buildIconAdornment(element.icon) } }} />
 * ```
 */
export function buildIconAdornment(icon: Icon | undefined): React.ReactNode | undefined {
	if (!icon?.iconName) return undefined;

	return (
		<InputAdornment position="start">
			<IconRenderer icon={icon} size="small" color="action" />
		</InputAdornment>
	);
}
